import {provideBrowsingContext} from './env';

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  const original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(() => provideBrowsingContext(window => cb(window.location.href)));
}

function onPushState(cb) {
  provideBrowsingContext(({history}) => ['pushState', 'replaceState'].forEach(fnName => {
    hook(history, fnName, (_, __, url) => cb(url));
  }));
}

function onPopState(cb) {
  provideBrowsingContext(window => window.addEventListener('popstate', () => cb(window.location.href)));
}

export function listen(cb) {
  provideBrowsingContext(window => {
    let fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(event => event(toUrl => {
      cb(fromUrl, toUrl);
      fromUrl = toUrl;
    }));
  });
}

export function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}



// WEBPACK FOOTER //
// ./lib/navigator.js